import { Component, OnInit, Input } from '@angular/core';
import { SchemaField, Document } from '../../../store/models/document.model';
import { DynamicColumn } from '../dynamic-column';

@Component({
    selector: 'app-user-column',
    templateUrl: './user-column.component.html',
    styleUrls: ['./user-column.component.scss'],
    standalone: false
})
export class UserColumnComponent implements OnInit, DynamicColumn {
  @Input() field: SchemaField;
  @Input() document: Document;

  constructor() {}

  ngOnInit(): void {}

  get fieldValue(): string {
    return this.document?.[this.field.systemName];
  }
}
